module.exports = __webpack_public_path__ + "static/media/icon_upper.98aed708.svg";